import React from "react"
import { batch } from "@preact/signals-react";
import { useNavigate } from "react-router-dom";
import { localize } from "services/base";
import { change_favorite } from "services/user";
import { toggleModal } from "signals/modal";
import { confirm_type, selected_form_id } from "signals/user";
import { toggleLoader } from "signals/base";

export const List = ({data, index}) => {
	const t = (key) => localize(key);
	const navigate = useNavigate();

    const renderPhone = () =>{
        let code = Object.values(data?.country)[0][1];
        return `+${code} ${data?.phone_number}`
    }
    
    const renderDetailAddress = () =>{
        const district = Object.values(data?.district);
        const city = Object.values(data?.city);
        const province = Object.values(data?.province);
        const country = Object.values(data?.country)[0][0];
        return `${district}, ${city}, ${province}, ${country}`
    }

    const handleFavorite = () =>{
        if(!data?.is_favorite){
            toggleLoader(true)
            change_favorite({ "form_id": data?.form_id })
        }
    }

    const handleDelete = () =>{
        toggleModal({ name: 'confirm', state: true });
        batch(()=>{
            confirm_type.value = 'delete';
            selected_form_id.value = data?.form_id;
        })
    }

    const renderRightSection = () =>{
        return(
            <div className="right-section">
                <img 
                    onClick={()=>handleFavorite()} 
                    src={t(data?.is_favorite ? `img_star` : `img_not_main`)} 
                    className={`img-fluid ${data?.is_favorite ? '' : 'hoverable'}`} 
                    alt="notmain" 
                />
                <img 
                    onClick={() => navigate(`/form/${data?.form_id}`)} 
                    src={t('img_edit')} 
                    className="img-fluid hoverable" 
                    alt="edit" 
                />                
                <img 
                    onClick={() => handleDelete()} 
                    src={t('img_delete')} 
                    className="img-fluid hoverable" 
                    alt="delete" 
                />
            </div>
        )
    }

    return (
        <div className={
            `address px-2 py-1 p-lg-3 mb-4 
            ${data?.is_favorite ? 'main-address' : ''}`
        }>
            <p className="mb-0 mb-lg-3 fw-bold">{data?.address_name}</p>
            <p className="mb-0 mb-lg-1">{data?.name}</p>
            <p className="mb-0 mb-lg-1">{renderPhone()}</p>
            <p className="mb-0 mb-lg-1" style={{ width: "95%" }}>{data?.address}</p>
            <p className="mb-0 mb-lg-1">{renderDetailAddress()}</p>
            <p className="mb-0 mb-lg-1">{data?.postal_code}</p>
            {renderRightSection()}
        </div>
    )
}